
export default [
  {
    name: 'helpPage',
    path: '/helpPage',
    meta: {
      title: '帮助中心',
      href: '/helpPage',
      redirect: 'noredirect'
    },
    component: () => import(/* webpackChunkName: 'helpPage' */ '@/views/helpPage/newIndex')
  },
  {
    name: 'backStage',
    path: '/backStage',
    redirect: '/backStage/editHelpPage',
    noLevel: true,
    meta: {
      title: '帮助中心',
      href: '/backStage'
    },
    component: () => import(/* webpackChunkName: 'team' */ '@/views/backStage'),
    children: [
      {
        name: 'editHelpPage',
        path: 'editHelpPage',
        meta: {
          title: '管理后台',
          href: '/editHelpPage'
        },
        component: () => import(/* webpackChunkName: 'editHelpPage' */ '@/views/backStage/editHelpPage')
      },
      {
        name: 'notice',
        path: 'notice',
        meta: {
          title: '管理后台',
          href: '/notice'
        },
        component: () => import(/* webpackChunkName: 'notice' */ '@/views/backStage/notice')
      },
    ]
  }
]
